import { defineStore } from 'pinia'
import { usePollingScheduler, type PollingOptions } from '@lecre/polling-scheduler'
import { warn as loggersWarn } from '@/utils/loggers'

// ポーリングラベルの型定義
export const POLLING_LABELS = {
  // TODO 実装
  DUMMY: 'dummyPollingLabel',
  DUMMY2: 'dummy2PollingLabel',
  TALK_UNREAD_POLLING: 'talkUnreadPolling',
  DEBOUNCE_SUBSCRIBE_KURADEN_STATUS: 'debounceSubscribeKuradenStatus',
  KURADEN_STATUS_POLLING: 'kuradenStatusPolling',
  KURATEL_WINDOW_CLOSED: 'kuraTelWindowClosed',
  KURAEMON_LIVE_LIST_POLLING: 'kuraemonLiveListPolling',
  // TREE_NODE_OPERATORS: 'treeNodeOperators',
  // UNORGANIZED_PHOTOS_STATUS_POLLING: 'initUnorganizedPhotosStatus',
  // START_TREE_EDITOR: 'startTreeEditor',
  // RELOAD_ALL_PHOTO_COUNT: 'reloadAllPhotoCount',
} as const

export type PollingLabel = typeof POLLING_LABELS[keyof typeof POLLING_LABELS]

export type { PollingOptions }

export const usePollingsStore = defineStore('pollings', () => {
  return usePollingScheduler<PollingLabel>({
    onInfo: (msg) => console.info(msg),
    onWarn: (msg, ctx) => loggersWarn(msg, ctx),
  })
})
